import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ForcePasswordChange from "@/pages/ForcePasswordChange";

export default function AppLayout() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#050505] text-zinc-500 font-mono-data text-xs tracking-widest">
        AUTHENTICATING&hellip;
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;

  // Hard enforcement: a forced password change blocks the entire app shell.
  if (user.must_change_password) {
    return (
      <>
        <ForcePasswordChange />
        <Toaster theme="dark" position="bottom-right" />
      </>
    );
  }

  return (
    <div className="flex min-h-screen bg-[#050505] text-white">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
